<template>
    <div class="generic-modal-container" v-if="!hidden" @click="bgClicked" :class="{
        opened: !hidden,
        'bg-clip-padding bg-gray-50 backdrop-filter bg-opacity-50': !hidden,
        opaque: isOpaque
    }">
        <div class="generic-modal">
            <div class="overflow-y-auto" style="height: 75vh">
                <div class="mt-4 mr-2" v-for="(contactList, type) in items">
                    <heading size="medium">{{ type }}</heading>
                    <ul>
                        <li v-for="contact in contactList" class="contact">
                            <div class="name" v-if="contact.has_company_and_person">
                                <a href="#">{{ contact.name }}
                                    <small>{{ contact.company }}</small>
                                </a>
                            </div>
                            <div v-else>
                                <div class="name" v-if="contact.has_person">
                                    {{ contact.name }}
                                </div>
                                <div class="name" v-else>
                                    {{ contact.company }}
                                </div>
                            </div>
                            <div class="meta">
                                {{ contact.position }}
                                <small>
                                    <template v-if="contact.phone">{{ contact.phone }}<br/></template>
                                    {{ contact.email }}</small>
                            </div>

                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import _ from "lodash";

export default {
    components: {},
    props: {
        isOpaque: true,
        packageReference: false,
        legacyPackageId: false,
    },
    data() {
        return {
            hidden: true,
            items: [],
        }
    },
    computed: {},
    methods: {
        closeModal() {
            window.Bus.emit('close-package-contacts')
            this.hidden = true;
        },
        openModal() {
            window.Bus.emit('close-all-slideovers');
            this.hidden = false;
        },
        bgClicked(e) {
            if (e.target.classList.contains('generic-modal-container')) {
                this.closeModal();
            }
        },
    },
    async mounted() {
        window.Bus.on('show-package-contacts', (reference) => {
            //YUK - copied from v1 contacts for now
            axios.get(appUrls.packages.contacts.index.replace('REPLACEME', this.legacyPackageId), {params: {group_by_letter: true}})
                .then(response => {
                    this.items = _.groupBy(_.sortBy(response.data.data, 'type'), function (contact) {
                        return contact.type;
                    });
                    this.openModal()
                });
        })
        window.Bus.on('close-all-slideovers', (reference) => {
            this.closeModal()
        })
        window.addEventListener('keydown', (e) => {
            if (e.ctrlKey || e.metaKey) {
                return;
            }
            if (e.keyCode === 27) {
                if (!this.hidden) {
                    this.closeModal()
                }
            }

            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(e.target.tagName)) {
                return;
            }
            if (['input', 'INPUT', 'textarea', 'TEXTAREA'].includes(document.activeElement.tagName)) {
                return;
            }

            if ((e.key === 'c') || (e.key === 'C')) {
                if (this.hidden) {
                    window.Bus.emit('show-package-contacts', this.packageReference)
                } else {
                    this.closeModal();
                }
                e.preventDefault();
                e.stopPropagation();
            }
        })
        window.addEventListener('resize', (e) => {
            if (window.innerWidth <= 830) {
                if (!this.hidden) {
                    this.closeModal();
                }
            }
        })
    }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/setup';

.generic-modal-container {
    display: none;

    &.opened {
        position: absolute;
        min-height: 100vh;
        width: 100vw;
        z-index: 100000;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        padding: 2em;
        @include desktop() {
            &.opaque {
                background-color: rgba(255, 255, 255, 1);
            }
        }
    }
}

.generic-modal {
    padding: 1em;
    @include grid-column(12);
    @include clearfix();
    @include desktop() {
        background-color: #fff;
        border-radius: 0.5em;
        box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
        @include grid-column(8);
        max-width: 1024px;
        padding: 2em;
    }

    div.actions {
        text-align: left;
        margin-top: 30px;

        a, input[type="submit"] {
            padding: 0.7em 0.7em 0.8em;
            text-decoration: none;
            color: #fff;
            border-radius: $standardBorderRadius;
        }

        input[type="submit"] {
            background-color: $green;
        }

        a {
            background-color: #999;
        }

        a.success {
            background-color: $green;
        }

        @include desktop() {
            float: right;
            text-align: right;
        }
    }
}

li.contact {
    margin: 1em 0;
}

.meta, .name {
    @include clearfix();

    small {
        float: right;
        text-align: right;
    }
}

.name small {
    opacity: 0.5;
}

.meta {
    font-size: 0.8em;
    opacity: 0.5;

    small {
        font-size: 1em;
    }
}

.person-meta, .company-meta {
    @include grid-column(6);
    @include mobile() {
        @include grid-column(12);
    }
}

.position {
    text-align: center;
    font-weight: 300;
    font-size: 2em;
    margin: 1em 0 2em;
}
</style>
